'use strict';

var _regeneratorRuntime = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils = require("../utils");

var simple_http_1 = require("./simple-http");

var debug = require('debug')('thor:http-provider:rpc');

exports.RPCMethodMap = new Map();

var HTTPPostProcessor = function HTTPPostProcessor(res) {
  if (res.Code === 0) {
    return Promise.reject(new Error("[thor-provider] Invalid response, check the host"));
  }

  if (res.Code !== 200) {
    return Promise.reject(new Error(res.Body ? res.Body : '[thor-provider] Invalid response code from provider: ' + res.Code));
  }

  return Promise.resolve(res.Body);
};

exports.RPCMethodMap.set('eth_getBlockByNumber', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            URL = host + '/blocks/' + utils.fromETHBlockNumber(rpc.params[0]);
            _context.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", rpc.makeResult(res));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
exports.RPCMethodMap.set('eth_getBlockByHash', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            URL = host + '/blocks/' + rpc.params[0];
            _context2.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", rpc.makeResult(res));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
});
exports.RPCMethodMap.set('eth_blockNumber', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            URL = host + '/blocks/best';
            _context3.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", rpc.makeResult(!res ? null : res.number));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
});
exports.RPCMethodMap.set('eth_getBalance', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            URL = host + '/accounts/' + rpc.params[0] + '?revision=' + utils.fromETHBlockNumberOrHash(rpc.params[1]);
            _context4.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", rpc.makeResult(!res ? null : res.balance));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
});
exports.RPCMethodMap.set('eth_getEnergy', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            URL = host + '/accounts/' + rpc.params[0] + '?revision=' + utils.fromETHBlockNumberOrHash(rpc.params[1]);
            _context5.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", rpc.makeResult(!res ? null : res.energy));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
});
exports.RPCMethodMap.set('eth_getCode', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            URL = host + '/accounts/' + rpc.params[0] + '/code?revision=' + utils.fromETHBlockNumberOrHash(rpc.params[1]);
            _context6.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", rpc.makeResult(!res ? null : res.code));

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
});
exports.RPCMethodMap.set('eth_getStorageAt', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            URL = host + '/accounts/' + rpc.params[0] + '/storage/' + utils.leftPadToBytes32(rpc.params[1]) + '?revision=' + utils.fromETHBlockNumberOrHash(rpc.params[2]);
            _context7.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", rpc.makeResult(!res ? null : res.value));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
});
exports.RPCMethodMap.set('eth_sendRawTransaction', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8() {
    var URL, reqBody, res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            URL = host + '/transactions';
            reqBody = {
              raw: rpc.params[0]
            };
            _context8.next = 4;
            return simple_http_1.HTTP.post(URL, reqBody, timeout).then(HTTPPostProcessor);

          case 4:
            res = _context8.sent;
            return _context8.abrupt("return", rpc.makeResult(!res ? null : res.id));

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
});
exports.RPCMethodMap.set('eth_getTransactionByHash', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            URL = host + '/transactions/' + rpc.params[0];
            _context9.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context9.sent;

            if (res) {
              _context9.next = 6;
              break;
            }

            return _context9.abrupt("return", rpc.makeResult(null));

          case 6:
            res.blockNumber = res.meta.blockNumber;
            return _context9.abrupt("return", rpc.makeResult(res));

          case 8:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
});
exports.RPCMethodMap.set('eth_getTransactionReceipt', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            URL = host + '/transactions/' + rpc.params[0] + '/receipt';
            _context10.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context10.sent;

            if (res) {
              _context10.next = 6;
              break;
            }

            return _context10.abrupt("return", rpc.makeResult(null));

          case 6:
            res.blockNumber = res.meta.blockNumber;
            res.blockHash = res.meta.blockID;
            res.transactionHash = res.meta.txID; // For compatible with ethereum's receipt

            if (res.reverted) {
              res.status = '0x0';
            } else {
              res.status = '0x1';
            }

            if (res.outputs.length === 1) {
              res.contractAddress = res.outputs[0].contractAddress;
            }

            return _context10.abrupt("return", rpc.makeResult(res));

          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
});
exports.RPCMethodMap.set('eth_call', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee11() {
    var extraURI, URL, reqBody, res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            extraURI = '';

            if (rpc.params[0].to) {
              extraURI = '/' + rpc.params[0].to;
            }

            extraURI += '?revision=' + utils.fromETHBlockNumberOrHash(rpc.params[1]);
            URL = host + '/accounts' + extraURI;
            reqBody = {
              value: rpc.params[0].value || '',
              data: rpc.params[0].data || '0x',
              gasPrice: rpc.params[0].gasPrice || ''
            };

            if (rpc.params[0].gas) {
              if (typeof rpc.params[0].gas === 'number') {
                reqBody.gas = rpc.params[0].gas;
              } else {
                reqBody.gas = parseInt(utils.sanitizeHex(rpc.params[0].gas), 16);
              }
            }

            if (rpc.params[0].from) {
              reqBody.caller = rpc.params[0].from;
            }

            _context11.next = 9;
            return simple_http_1.HTTP.post(URL, reqBody, timeout).then(HTTPPostProcessor);

          case 9:
            res = _context11.sent;

            if (res) {
              _context11.next = 14;
              break;
            }

            return _context11.abrupt("return", rpc.makeResult(null));

          case 14:
            if (!(res.reverted || res.vmError)) {
              _context11.next = 19;
              break;
            }

            if (res.data && res.data.startsWith('0x08c379a0')) {
              debug('VM reverted with message:', require('web3-eth-abi').decodeParameter('string', res.data.replace(/^0x08c379a0/i, '')));
            } else if (res.vmError) {
              debug('VM returned error:', res.vmError);
            }

            return _context11.abrupt("return", rpc.makeResult(null));

          case 19:
            return _context11.abrupt("return", rpc.makeResult(res.data === '0x' ? '' : res.data));

          case 20:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
});
exports.RPCMethodMap.set('eth_estimateGas', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee12() {
    var extraURI, URL, reqBody, res, intrinsicGas;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            extraURI = '';

            if (rpc.params[0].to) {
              extraURI = '/' + rpc.params[0].to;
            }

            extraURI += '?revision=' + utils.fromETHBlockNumberOrHash(rpc.params[1]);
            URL = host + '/accounts' + extraURI;
            reqBody = {
              value: rpc.params[0].value || '',
              data: rpc.params[0].data || '0x',
              gasPrice: rpc.params[0].gasPrice || ''
            };

            if (rpc.params[0].from) {
              reqBody.caller = rpc.params[0].from;
            }

            _context12.next = 8;
            return simple_http_1.HTTP.post(URL, reqBody, timeout).then(HTTPPostProcessor);

          case 8:
            res = _context12.sent;

            if (res) {
              _context12.next = 13;
              break;
            }

            return _context12.abrupt("return", rpc.makeResult(null));

          case 13:
            if (!(res.reverted || res.vmError)) {
              _context12.next = 18;
              break;
            }

            if (res.data && res.data.startsWith('0x08c379a0')) {
              debug('VM reverted with message:', require('web3-eth-abi').decodeParameter('string', res.data.replace(/^0x08c379a0/i, '')));
            } else if (res.vmError) {
              debug('VM returned error:', res.vmError);
            }

            return _context12.abrupt("return", rpc.makeResult(null));

          case 18:
            debug('VM gas:', res.gasUsed); // ignore the overflow since block gas limit is uint64 and JavaScript's max number is 2^53

            intrinsicGas = utils.calcIntrinsicGas(Object.assign(reqBody, {
              to: rpc.params[0].to
            }));

            if (!(res.gasUsed === 0 && reqBody.data === '0x')) {
              _context12.next = 24;
              break;
            }

            return _context12.abrupt("return", rpc.makeResult(intrinsicGas));

          case 24:
            return _context12.abrupt("return", rpc.makeResult(Math.floor(res.gasUsed * 1.2) + intrinsicGas));

          case 25:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
});
exports.RPCMethodMap.set('eth_getLogs', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13() {
    var query, URL, reqBody, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            query = '';

            if (rpc.params[0].address) {
              query = '&address=' + rpc.params[0].address;
            }

            if (rpc.params[0].order && (rpc.params[0].order.toUpperCase() === 'ASC' || rpc.params[0].order.toUpperCase() === 'DESC')) {
              query += '&order=' + rpc.params[0].order.toUpperCase();
            }

            query = query.replace('&', '?');
            URL = host + '/logs/events' + query;
            reqBody = utils.formatLogQuery(rpc.params[0]);
            _context13.next = 8;
            return simple_http_1.HTTP.post(URL, reqBody, timeout).then(HTTPPostProcessor);

          case 8:
            res = _context13.sent;

            if (res) {
              _context13.next = 11;
              break;
            }

            return _context13.abrupt("return", rpc.makeResult(null));

          case 11:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context13.prev = 14;

            for (_iterator = res[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              item = _step.value;
              item.blockNumber = item.meta.blockNumber;
              item.blockHash = item.meta.blockID;
              item.transactionHash = item.meta.txID;
            }

            _context13.next = 22;
            break;

          case 18:
            _context13.prev = 18;
            _context13.t0 = _context13["catch"](14);
            _didIteratorError = true;
            _iteratorError = _context13.t0;

          case 22:
            _context13.prev = 22;
            _context13.prev = 23;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 25:
            _context13.prev = 25;

            if (!_didIteratorError) {
              _context13.next = 28;
              break;
            }

            throw _iteratorError;

          case 28:
            return _context13.finish(25);

          case 29:
            return _context13.finish(22);

          case 30:
            return _context13.abrupt("return", rpc.makeResult(res));

          case 31:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[14, 18, 22, 30], [23,, 25, 29]]);
  }));
});
exports.RPCMethodMap.set('eth_getBlockRef', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            URL = host + '/blocks/best';
            _context14.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context14.sent;

            if (!(!res || !res.id)) {
              _context14.next = 6;
              break;
            }

            return _context14.abrupt("return", rpc.makeResult(null));

          case 6:
            return _context14.abrupt("return", rpc.makeResult(res.id.substr(0, 18)));

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
});
exports.RPCMethodMap.set('eth_getChainTag', function (rpc, host, timeout) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee15() {
    var URL, res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            URL = host + '/blocks/0';
            _context15.next = 3;
            return simple_http_1.HTTP.get(URL, timeout).then(HTTPPostProcessor);

          case 3:
            res = _context15.sent;

            if (!(!res || !res.id || res.id.length !== 66)) {
              _context15.next = 6;
              break;
            }

            return _context15.abrupt("return", rpc.makeResult(null));

          case 6:
            return _context15.abrupt("return", rpc.makeResult('0x' + res.id.substr(64, 2)));

          case 7:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
});